module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "complete-data text-xs-left mt-3"
  }, [_c('label', {
    staticClass: "label-title"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    staticClass: "input-switch",
    attrs: {
      "hide-details": "",
      "label": "Datos de la organización",
      "color": "success"
    },
    model: {
      value: (_vm.completeDataActive),
      callback: function($$v) {
        _vm.completeDataActive = $$v
      },
      expression: "completeDataActive"
    }
  })], 1), _vm._v(" "), (_vm.completeDataActive) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Nombre Completo",
      "placeholder": "Nombre Completo"
    },
    model: {
      value: (_vm.newCustomer.rzSocial),
      callback: function($$v) {
        _vm.newCustomer.rzSocial = $$v
      },
      expression: "newCustomer.rzSocial"
    }
  }), _vm._v(" "), (!_vm.$v.newCustomer.rzSocial.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\tLa razón social es requerida\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Nombre Comercial",
      "placeholder": "Nombre Comercial"
    },
    model: {
      value: (_vm.newCustomer.tradename),
      callback: function($$v) {
        _vm.newCustomer.tradename = $$v
      },
      expression: "newCustomer.tradename"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label": "",
      "labelText": "Tipo de Cliente",
      "itemText": "name",
      "itemValue": "id",
      "items": _vm.channels
    },
    on: {
      "input": _vm.getChannelsInformation
    },
    model: {
      value: (_vm.newCustomer.channelId),
      callback: function($$v) {
        _vm.newCustomer.channelId = $$v
      },
      expression: "newCustomer.channelId"
    }
  }), _vm._v(" "), (!_vm.$v.newCustomer.channelId.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\tEl tipo de cliente es requerido.\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label-text": "Seleccione Canal",
      "item-text": "name",
      "item-value": "id",
      "items": _vm.specificsChannels
    },
    model: {
      value: (_vm.channelInformationsId),
      callback: function($$v) {
        _vm.channelInformationsId = $$v
      },
      expression: "channelInformationsId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Ruc",
      "placeholder": "Ruc"
    },
    model: {
      value: (_vm.newCustomer.numDocument),
      callback: function($$v) {
        _vm.newCustomer.numDocument = $$v
      },
      expression: "newCustomer.numDocument"
    }
  }), _vm._v(" "), (!_vm.$v.newCustomer.numDocument.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\tEl número de documento es requerido.\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Rubro",
      "placeholder": "Rubro"
    },
    model: {
      value: (_vm.newCustomer.category),
      callback: function($$v) {
        _vm.newCustomer.category = $$v
      },
      expression: "newCustomer.category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Correo",
      "placeholder": "Correo",
      "type": "email"
    },
    model: {
      value: (_vm.newCustomer.email),
      callback: function($$v) {
        _vm.newCustomer.email = $$v
      },
      expression: "newCustomer.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Teléfono",
      "placeholder": "Teléfono",
      "type": "tel"
    },
    model: {
      value: (_vm.newCustomer.phone),
      callback: function($$v) {
        _vm.newCustomer.phone = $$v
      },
      expression: "newCustomer.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Celular",
      "placeholder": "Celular",
      "type": "tel"
    },
    model: {
      value: (_vm.newCustomer.movil),
      callback: function($$v) {
        _vm.newCustomer.movil = $$v
      },
      expression: "newCustomer.movil"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label": "",
      "labelText": "Vendedor",
      "itemText": "name",
      "itemValue": "id",
      "items": _vm.sellers
    },
    model: {
      value: (_vm.newCustomer.employeeId),
      callback: function($$v) {
        _vm.newCustomer.employeeId = $$v
      },
      expression: "newCustomer.employeeId"
    }
  }), _vm._v(" "), (!_vm.$v.newCustomer.employeeId.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\tEl Vendedor es requerido.\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-date', {
    attrs: {
      "label": "",
      "labelText": "Aniversario"
    },
    model: {
      value: (_vm.newCustomer.anniversaryDate),
      callback: function($$v) {
        _vm.newCustomer.anniversaryDate = $$v
      },
      expression: "newCustomer.anniversaryDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-date', {
    attrs: {
      "label": "",
      "labelText": "Cumpleaños"
    },
    model: {
      value: (_vm.newCustomer.dateBirth),
      callback: function($$v) {
        _vm.newCustomer.dateBirth = $$v
      },
      expression: "newCustomer.dateBirth"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label": "",
      "labelText": "País",
      "itemText": "name",
      "itemValue": "id",
      "items": _vm.countries
    },
    on: {
      "input": _vm.filterCities
    },
    model: {
      value: (_vm.newCustomer.country),
      callback: function($$v) {
        _vm.newCustomer.country = $$v
      },
      expression: "newCustomer.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label": "",
      "labelText": "Ciudad",
      "itemText": "province",
      "itemValue": "id",
      "items": _vm.cities
    },
    model: {
      value: (_vm.newCustomer.city),
      callback: function($$v) {
        _vm.newCustomer.city = $$v
      },
      expression: "newCustomer.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Dirección",
      "placeholder": "Dirección"
    },
    model: {
      value: (_vm.newCustomer.address),
      callback: function($$v) {
        _vm.newCustomer.address = $$v
      },
      expression: "newCustomer.address"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('hr', {
    staticClass: "section-spacer"
  }), _vm._v(" "), _c('section', {
    staticClass: "contact-data text-xs-left mt-3"
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    staticClass: "input-switch",
    attrs: {
      "hide-details": "",
      "label": "Datos del contacto",
      "color": "success"
    },
    model: {
      value: (_vm.contactDataActive),
      callback: function($$v) {
        _vm.contactDataActive = $$v
      },
      expression: "contactDataActive"
    }
  })], 1), _vm._v(" "), (_vm.contactDataActive) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Nombre",
      "placeholder": "Nombre",
      "value": _vm.newContact.name
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Apellido",
      "placeholder": "Apellido"
    },
    model: {
      value: (_vm.newContact.lastname),
      callback: function($$v) {
        _vm.newContact.lastname = $$v
      },
      expression: "newContact.lastname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-date', {
    attrs: {
      "label": "",
      "labelText": "Fecha de Nacimiento"
    },
    model: {
      value: (_vm.newContact.dateBirth),
      callback: function($$v) {
        _vm.newContact.dateBirth = $$v
      },
      expression: "newContact.dateBirth"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "autocomplete": "",
      "label": "",
      "labelText": "País",
      "itemText": "name",
      "itemValue": "name",
      "items": _vm.countries
    },
    model: {
      value: (_vm.newContact.countryId),
      callback: function($$v) {
        _vm.newContact.countryId = $$v
      },
      expression: "newContact.countryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label": "",
      "labelText": "Género",
      "itemText": "name",
      "itemValue": "id",
      "items": _vm.genders
    },
    model: {
      value: (_vm.newContact.gender),
      callback: function($$v) {
        _vm.newContact.gender = $$v
      },
      expression: "newContact.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label": "",
      "labelText": "Estado Civil",
      "itemText": "name",
      "itemValue": "name",
      "items": _vm.civilStatus
    },
    model: {
      value: (_vm.newContact.civilStatus),
      callback: function($$v) {
        _vm.newContact.civilStatus = $$v
      },
      expression: "newContact.civilStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Correo eletrónico",
      "placeholder": "Correo eletrónico",
      "type": "email"
    },
    model: {
      value: (_vm.newContact.email),
      callback: function($$v) {
        _vm.newContact.email = $$v
      },
      expression: "newContact.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('type-document-component', {
    attrs: {
      "label": "",
      "labelText": "Tipo de identificación",
      "placeholder": "Tipo de identificación"
    },
    on: {
      "input": _vm.getCustomer,
      "customerDetail": _vm.typeDocument,
      "customer-error": _vm.getCustomerError
    },
    model: {
      value: (_vm.newContact.numDocument),
      callback: function($$v) {
        _vm.newContact.numDocument = $$v
      },
      expression: "newContact.numDocument"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Niños",
      "placeholder": "Niños"
    },
    model: {
      value: (_vm.newContact.childrens),
      callback: function($$v) {
        _vm.newContact.childrens = $$v
      },
      expression: "newContact.childrens"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Bebes",
      "placeholder": "Bebes"
    },
    model: {
      value: (_vm.newContact.babies),
      callback: function($$v) {
        _vm.newContact.babies = $$v
      },
      expression: "newContact.babies"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Teléfono",
      "placeholder": "Teléfono",
      "type": "tel"
    },
    model: {
      value: (_vm.newContact.phone),
      callback: function($$v) {
        _vm.newContact.phone = $$v
      },
      expression: "newContact.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Facebook",
      "placeholder": "Facebook"
    },
    model: {
      value: (_vm.newContact.facebook),
      callback: function($$v) {
        _vm.newContact.facebook = $$v
      },
      expression: "newContact.facebook"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Twitter",
      "placeholder": "Twitter"
    },
    model: {
      value: (_vm.newContact.twitter),
      callback: function($$v) {
        _vm.newContact.twitter = $$v
      },
      expression: "newContact.twitter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Instagram",
      "placeholder": "Instagram"
    },
    model: {
      value: (_vm.newContact.instagram),
      callback: function($$v) {
        _vm.newContact.instagram = $$v
      },
      expression: "newContact.instagram"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Dirección",
      "placeholder": "Dirección"
    },
    model: {
      value: (_vm.newContact.address),
      callback: function($$v) {
        _vm.newContact.address = $$v
      },
      expression: "newContact.address"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('hr', {
    staticClass: "section-spacer"
  }), _vm._v(" "), _c('section', {
    staticClass: "rate text-xs-left mt-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Tarifa")]), _vm._v(" "), _c('rate-component', {
    staticClass: "rate-component",
    attrs: {
      "alreadyExistRate": !!_vm.customerInfo.id,
      "rates": _vm.rateAvailability
    },
    on: {
      "rate-event": _vm.getRate
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "section-spacer"
  }), _vm._v(" "), _c('section', {
    staticClass: "loyalty text-xs-left mt-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Loyalty")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Puntos",
      "placeholder": "Puntos"
    },
    model: {
      value: (_vm.loyalty.points),
      callback: function($$v) {
        _vm.loyalty.points = $$v
      },
      expression: "loyalty.points"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "section-spacer"
  }), _vm._v(" "), _c('section', {
    staticClass: "credit text-xs-left mt-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Crédito")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label-text": "Día",
      "placeholder": "Día"
    },
    model: {
      value: (_vm.credit.days),
      callback: function($$v) {
        _vm.credit.days = $$v
      },
      expression: "credit.days"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-date', {
    attrs: {
      "labelText": "Fecha Aprobada",
      "icon": "event"
    },
    model: {
      value: (_vm.credit.date),
      callback: function($$v) {
        _vm.credit.date = $$v
      },
      expression: "credit.date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "d-flex": "",
      "justify-start": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-save white--text",
    attrs: {
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.saveCustomer
    }
  }, [_vm._v("\n\t\t\t\t\tGuardar\n\t\t\t\t")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a64f147","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/customers/subComponents/Customer-Details.vue
// module id = 1622
// module chunks = 2